export const state = () => {
  return {
    favorites: [],
  }
}
